import cn from 'classnames';
import { ComponentPropsWithoutRef } from 'react';
import { Root } from '@radix-ui/react-separator';
import styles from './separator.module.scss';


export function Separator ({
    className,
    orientation = 'horizontal',
    decorative = true,
    ...props
}: ComponentPropsWithoutRef<typeof Root>) {
    return (
        <Root
            decorative={ decorative }
            orientation={ orientation }
            className={ cn(styles.root, {
                [styles.vertical]: orientation === 'vertical',
            }, className) }
            { ...props }
        />
    );
}
